import React from "react";
import styled, { keyframes } from "styled-components";

const Loader = ({ size = 40, color = "#2877D9" }) => {
  return (
    <LoaderContainer>
      <SpinnerRing $size={size} $color={color}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </SpinnerRing>
    </LoaderContainer>
  );
};

export default Loader;

const LoaderContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerRing = styled.div`
  display: inline-block;
  position: relative;
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border: ${(props) => Math.max(2, props.$size / 13)}px solid transparent;
    border-radius: 50%;
    animation: ${spin} 1.8s cubic-bezier(0.5, 0, 0.5, 1) infinite;

    &:nth-child(1) {
      border-top-color: ${(props) => props.$color};
      animation-delay: -0.45s;
    }

    &:nth-child(2) {
      border-top-color: ${(props) => props.$color};
      opacity: 0.7;
      animation-delay: -0.3s;
    }

    &:nth-child(3) {
      border-top-color: ${(props) => props.$color};
      opacity: 0.5;
      animation-delay: -0.15s;
    }

    &:nth-child(4) {
      border-top-color: ${(props) => props.$color};
      opacity: 0.3;
    }
  }
`;
